import styled, { keyframes } from "styled-components";
import { SPACING, ANIMATION } from "../../../utils/constants";

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const float = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}`;

export const EmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${SPACING.xxl + SPACING.xl}px ${SPACING.xl}px;
  text-align: center;
  background: var(--empty-state-background);
  border-radius: 16px;
  border: 2px dashed var(--empty-state-border);
  margin: ${SPACING.md}px 0;
  animation: ${fadeInUp} ${ANIMATION.duration.slower}
    ${ANIMATION.easing.easeOut};
  transition: ${ANIMATION.transitions.allSlow};

  &:hover {
    border-color: var(--color-primary);
    transform: translateY(-2px);
    box-shadow: var(--shadow-large);
  }

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 96px;
    height: 96px;
    margin-bottom: ${SPACING.lg}px;
    padding: ${SPACING.md + SPACING.xs}px;
    background: var(--empty-state-icon-background);
    border-radius: 50%;
    color: var(--empty-state-icon-color);
    font-size: var(--text-display-xl);
    animation: ${float} 3s ease-in-out infinite;
    box-shadow: var(--shadow-medium);

    svg {
      width: 56px;
      height: 56px;
    }
  }

  h3 {
    margin: 0 0 ${SPACING.sm + SPACING.xs}px 0;
    color: var(--color-text-default);
    font-size: var(--text-xxl);
    font-weight: 700;
    letter-spacing: -0.02em;
  }

  p {
    margin: 0 0 ${SPACING.xl}px 0;
    color: var(--color-text-secondary);
    font-size: var(--text-md);
    max-width: 480px;
    line-height: 1.7;
    letter-spacing: 0.01em;
  }

  .action {
    margin-top: ${SPACING.sm}px;
    animation: ${fadeInUp} 0.6s ${ANIMATION.easing.easeOut}
      ${ANIMATION.delay.long} both;
  }
`;
